export enum NEConfigSelectorTypes {
  SelectedNetworkElement = '[NE Config] Selected Network Element',
  SetAttributesSource = '[NE Config] Set Attributes Source',
  BoundarySettings = '[NE Config] Boundary Settings',
  FormDefinitions = '[NE Config] Form Definitions',
  UIValues = '[NE Config] UI Values',
  PressureSettings = '[NE Config] Pressure Settings',
  FormAdditionalSettings = '[NE Config] Form Additional Settings',
}
